/**
 * Translated display labels for admin roles.
 *
 * The role and capability model lives in `@repo/shared/roles-capabilities`;
 * this file holds only `getRoleLabel`, which needs client translations and so
 * can't live in the shared package.
 */

import type { TLabel } from 'util/stdtypes';
import { t } from 'util/stdtypes';

export function getRoleLabel(roleKey: string): TLabel {
    const roleLabels: Record<string, TLabel> = {
        Owner: t('roles.owner', 'Owner'),
        Editor: t('roles.editor', 'Editor'),
        Observer: t('roles.observer', 'Observer'),
        Developer: t('roles.developer', 'Developer'),
        'Super-Moderator': t('roles.super_moderator', 'Super-Moderator'),
        Moderator: t('roles.moderator', 'Moderator'),
        Editorial: t('roles.editorial', 'Editorial'),
        Analyst: t('roles.analyst', 'Analyst'),
    };
    return roleLabels[roleKey] ?? t('roles.unknown', 'Unknown');
}
